<template>
  <div class="marquee" v-if="marqueelist && marqueelist.length > 0">
    <van-swipe
      style="height: 0.3rem"
      :show-indicators="marqueeOptions.isindicators"
      :autoplay="marqueeOptions.autoplay"
      :loop="marqueeOptions.loop"
      vertical
    >
      <van-swipe-item v-for="(item, index) of marqueelist" :key="index">
        <div class="marqueeitem">
          <img
            v-if="item.head"
            :src="item.head"
            @error="
              (event) => {
                let img = event.srcElement
                img.src = errorHeadImg
                img.onerror = null
              }
            "
          />
          <img v-else :src="errorHeadImg" />
          {{
            (item.name ? (item.name.length <= 6 ? item.name : item.name.slice(0, 6) + '...') : '') +
            item.time +
            item.text
          }}
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import Vue from 'vue'
import { Swipe, SwipeItem } from 'vant'
Vue.use(Swipe)
Vue.use(SwipeItem)
export default {
  name: 'marquee',
  props: {
    itemid: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      marqueelist: [],
      marqueeOptions: {
        autoplay: 1000,
        isindicators: false,
        loop: true
      }
    }
  },
  mounted: function () {
    this.getData()
  },
  methods: {
    getData: function () {
      var url =
        this.$ajax.getItemMarquee_URL + '?item_base_id=' + this.itemid + '&type=' + this.type
      var that = this
      that.$customRequestAjax(url).then(function (res) {
        if (res.data.code == 200) {
          that.marqueelist = res.data.marqueeList
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.marquee {
  position: fixed;
  left: 0.1rem;
  top: 0.5rem;
  z-index: 1;
  width: 62%;
  height: 0.3rem;
  background: #fc0324;
  opacity: 0.6;
  border-radius: 0.15rem;
  padding: 0.01rem;
  overflow: hidden;
  .marqueeitem {
    font-size: 0.13rem;
    color: #ffffff;
    line-height: 0.28rem;
    img {
      width: 0.28rem;
      height: 0.28rem;
      float: left;
      border-radius: 0.14rem;
      margin-right: 0.1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/vanMarquee.vue